export const getDeleteInboxItemConfirmAlertMessage = () => 'Are you sure you want to delete this bill?';
export const getDeleteInboxItemSuccessMessage = () => 'Bill deleted';
